import { APP_NAME } from './config'

/**
 * The web-form opt-in: the exact words next to the unchecked checkbox on every join page
 * (/join/<code>), and the version stored with each consent record. Changing a word here is a new
 * version: bump CONSENT_VERSION, and update docs/MESSAGING-COMPLIANCE.md and the /opt-in page
 * screenshots (`pnpm screenshots`).
 */
export const CONSENT_VERSION = 'web-2026-10-24'

/** The checkbox text in parts, so the page can link "Terms" and "Privacy Policy". */
export const CONSENT_PARTS = {
  lead: `I agree to receive text message updates about this event from ${APP_NAME}. Message frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help. See our `,
  terms: 'Terms',
  and: ' and ',
  privacy: 'Privacy Policy',
  end: '.',
} as const

export const CONSENT_TEXT =
  CONSENT_PARTS.lead +
  CONSENT_PARTS.terms +
  CONSENT_PARTS.and +
  CONSENT_PARTS.privacy +
  CONSENT_PARTS.end

/** The join form's submit button on a public event (anyone with the link joins at once). */
export const JOIN_BUTTON = 'Yes, send me updates'

/** The same form's button on a private event, where the creator approves each request. */
export const REQUEST_BUTTON = 'Request updates'
